import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import { createRouter,createWebHistory } from 'vue-router'
import SimpleCalculatorPage from './components/SimpleCalculatorPage.vue';
import CalendarConverterPage from './components/CalendarConverterPage.vue';
import TimezoneConverterPage from './components/TimezoneConverterPage.vue';
import UnitConversionPage from './components/UnitConversionPage.vue';
import AboutPage from './components/AboutPage.vue';
import CreatorPage from './components/CreatorPage.vue';
import './assets/global.css';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/', redirect: '/simple-calculator'},
        { path: '/simple-calculator', component: SimpleCalculatorPage, name:'SimpleCalculator' },
        { path: '/calendar-converter', component: CalendarConverterPage, name:'CalendarConverter' },
        { path: '/timezone-converter', component: TimezoneConverterPage, name:'TimezoneConverter' },
        { path: '/unit-converter', component: UnitConversionPage, name:'UnitConverter' },
        { path: '/about', component: AboutPage, name:'About' },
        { path: '/untitled-9', component: CreatorPage, name:'Untitled9' },
    ]
});

const app = createApp(App)

app.use(router)
app.use(createPinia())
app.mount('#app')